// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__kMlL_","light":"style_light__5Tutx","dark":"style_dark___ozd2","icon":"style_icon__B7Zzt","block":"style_block__BbaM0","link":"style_link__VHhiN"};